import { useShops } from 'src/hooks/useShops';
import { ShopsContext } from 'src/stores/Shops';
import { ProviderProps } from 'src/types/provider';

const ShopsProvider: React.FC<ProviderProps> = ({ children }) => {
  const { shops } = useShops();

  return <ShopsContext.Provider value={shops ?? []}>{children}</ShopsContext.Provider>;
};

export { ShopsProvider };
